import { render, staticRenderFns } from "./CommonMonitorSign.vue?vue&type=template&id=513df682&scoped=true"
import script from "./CommonMonitorSign.vue?vue&type=script&lang=js"
export * from "./CommonMonitorSign.vue?vue&type=script&lang=js"
import style0 from "./CommonMonitorSign.vue?vue&type=style&index=0&id=513df682&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513df682",
  null
  
)

export default component.exports